export const videosPerPage = 27;
export const noCookiesRoutes = ['videowall-embed', 'confidenceWall-embed'];
